import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/auth/AuthContext";
import { Database } from "@/integrations/supabase/types";

type Profile = Database['public']['Tables']['profiles']['Row'];

export const useProfile = () => {
  const [profile, setProfile] = useState<Profile | null>(null);
  const { user } = useAuth();

  const fetchProfile = useCallback(async () => {
    if (!user?.email) return;

    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("email", user.email)
      .single();

    if (error) {
      console.error("Error fetching profile:", error.message);
      return;
    }

    setProfile(data);
  }, [user?.email]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return { profile, fetchProfile };
};